<template>
  <section id="pageMainContent" class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  height: calc(100vh - 48px);
  width: 100%;
  margin-left: 180px;
  position: relative;
  overflow: auto;
  background-color: #F4F5F9;
}
/*.fixed-header+.app-main {*/
/*  padding-top: 50px;*/
/*}*/
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    // padding-right: 15px;
  }
}
</style>
